import { render, staticRenderFns } from "./check_order.vue?vue&type=template&id=b5c65422&scoped=true"
import script from "./check_order.vue?vue&type=script&lang=js"
export * from "./check_order.vue?vue&type=script&lang=js"
import style0 from "./check_order.vue?vue&type=style&index=0&id=b5c65422&prod&scoped=true&lang=css"
import style1 from "./check_order.vue?vue&type=style&index=1&id=b5c65422&prod&lang=css"
import style2 from "./check_order.vue?vue&type=style&index=2&id=b5c65422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c65422",
  null
  
)

export default component.exports